export default function renderUserName(user) {
    return user.name ?
        `${user.name} ${user.surname}` :
        user.email;
}